import React, { useEffect, useRef, useState } from 'react'
import { Element } from 'react-scroll'

import RemixViewer from '../../common/components/RemixViewer/RemixViewer.jsx'
import { convertPreviewUrlToRemixHTMLUrl } from '../../common/components/RemixViewer/utils.js'

const FeedbackSection = ({ activeType, t }) => {
    const [remixUrl, setRemixUrl] = useState('')

    useEffect(() => {
        if (activeType.feedbackPreview) {
            setRemixUrl(convertPreviewUrlToRemixHTMLUrl(activeType.feedbackPreview))
        }
    }, [activeType.feedbackPreview])

    return (
        <Element name="landing_feedback_section">
            <div className="feedback-section">
                <ul className="balls">
                    <li className="ball ball--1" />
                    <li className="ball ball--2" />
                    <li className="ball ball--3" />
                    <li className="ball ball--4" />
                    <li className="ball ball--5" />
                </ul>
                <div className="feedback-section__title">{t(activeType.texts.feedbackSection)}</div>
                <div className="feedback-section__action-box">
                    <div className="feedback-section__preview-box">
                        <RemixViewer remixUrl={remixUrl} device="desktop" />
                    </div>
                </div>
            </div>
        </Element>
    )
}

export default FeedbackSection
